import { BackEndUrlsEnum } from '@/shared/Enums/BackEndUrlsEnum';
import { AttorneyPartyTypeModel } from '@/models/AttorneyPartyTypeModel';
import AxiosService from '@/services/AxiosService';
import LoaderService from '@/services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { PartySefaEnum } from '@/components/AttorneyRegistration/Component/Enums/PartySefaEnum';
import { v4 as uuidv4 } from 'uuid';
import { SefaAdditionalFeilds } from '@/models/SefaAdditionalFeilds';
import { SefaResponseModel } from '@/models/BuilderModels/SefaResponseModel';
import ValidationService from '@/services/ValidationService';
import moment from 'moment-hijri';
import { ClauseResponse } from '@/components/AttorneyRegistration/Component/Models/ClauseResponse';



@Service()
export default class SharedService {
  @Inject(AxiosService) public axiosService!: AxiosService;
  @Inject(LoaderService) public loaderService!: LoaderService;
  @Inject(ValidationService) public validationService!: ValidationService;


  public async getPartySefaLookups(): Promise<AttorneyPartyTypeModel[]> {
    const model: AttorneyPartyTypeModel[] = [
      { id: 1, name: 'أصالة عن نفسه' },
      // { id: 29, name: 'وكيل بموجب وكالة' },
      // { id: 20, name: 'حارس قضائي' },
      // { id: 16, name: 'أمين عام' },
      // { id: 31, name: 'وصي بموجب صك وصية' },
      // { id: 28, name: 'مصفى شركة' },
    ];
    return model;
  }

  public async getSecondPartySefaLookups(): Promise<AttorneyPartyTypeModel[]> {
    // let model: AttorneyPartyTypeModel[] = [
    //   { id: 1, name: 'أصالة عن نفسه' },
    //   { id: 35, name: 'محامي' },
    //   { id: 36, name: 'قريب حتى الدرجة الرابعة' },
    // ];
    // if (isCompany) {
    //   model = model.filter((s) => {
    //     return s.id != PartySefaEnum.FourthRelation;
    //   });
    // }
    // return model;

    this.loaderService.ShowLoader();
    const result = await this.axiosService.axiosInstance.get(
      BackEndUrlsEnum.getSecondPartySefaLookups
    );
    this.loaderService.HideLoader();
    return result.data;

  }

  public GetSefaDisc(selectedPartySefaId: number) {
    if (selectedPartySefaId === PartySefaEnum.asala) {
      return 'أصالة عن نفسه';
    }
    if (selectedPartySefaId === PartySefaEnum.bemogabWekala) {
      return 'وكيل بموجب وكالة';
    }
    return '';
  }

  public formatHijriDate(hijriDate: string): string {
    if (hijriDate.length != 8) {
      throw new Error('Invalid date format. Expected YYYYMMDD.');
    }

    const yyyy = hijriDate.substring(0, 4);
    const mm = hijriDate.substring(4, 6);
    const dd = hijriDate.substring(6, 8);

    return `${yyyy}/${mm}/${dd}`;
  }

  public getFormatedDate(date: string): string {
    if (
      date && date.toString() != ''
    ) {
      let formate = this.validationService.getDateFormate(date);

      if (formate != '') {
        let m = moment(date, formate);
        let returnValue = m.locale('en').format('iYYYY/iMM/iDD');

        if (returnValue.toString().indexOf('NaN') > -1) {
          returnValue = this.parseDateManual(date);
        }
        return returnValue;
      } else {
        return this.parseDateManual(date);


      }
    }
    return '';
  }

  private parseDateManual(date: string) {
    return date.replace(/[^\x00-\x7F]/g, "").toString().replace(
      /(\d{4})(\d{2})(\d{2})/,
      '$1/$2/$3'
    ).replace(/(\d{ 4})\/(\d{2})\/(\d{2})/, '$1/$2/$3');
  }

  public getSecondPartySefaComponent(selectedSefa: number) {
    if (selectedSefa == PartySefaEnum.FourthRelation) {
      return 'FourthRelationComponent';
    }

    if (selectedSefa == PartySefaEnum.Lawyer) {
      return 'LawyerComponent';
    }

    if (selectedSefa == PartySefaEnum.TrainerLawyer) {
      return 'TrainerLawyerComponent';
    }


    return '';
  }

  public getSecondPartySefaComponent_New(selectedSefa: SefaResponseModel) {
    if (selectedSefa.id == PartySefaEnum.FourthRelation) {
      return 'FourthRelationComponent';
    }

    if (selectedSefa.id == PartySefaEnum.Lawyer) {
      return 'LawyerComponent';
    }

    if (selectedSefa.id == PartySefaEnum.TrainerLawyer) {
      return 'TrainerLawyerComponent';
    }


    return '';
  }


  public GenerateGuid(): string {
    let myuuid = uuidv4();
    return myuuid;
  }

  public GetSefaExternalFeilds(
    partySefaType: number,
    sefaData: any
  ): SefaAdditionalFeilds[] {
    let retList: SefaAdditionalFeilds[] = [];
    switch (partySefaType) {
      case PartySefaEnum.Lawyer:
        retList = retList.concat({
          Label: 'SefaProps.lawyerLicense',
          Value: sefaData.licenseNumber || sefaData.LicenseNumber,
        } as SefaAdditionalFeilds);


        // let dateValue = '';
        // if (sefaData.issueDate != undefined) {
        //   if (sefaData.issueDate.HijriDate.indexOf('/') > -1) {
        //     dateValue = sefaData.issueDate.HijriDate;
        //   } else {
        //     dateValue = this.formatHijriDate(sefaData.issueDate.HijriDate);
        //   }
        // }

        // if (sefaData.IssueDate != undefined) {

        //   if (sefaData.IssueDate.HijriDate.indexOf('/') > -1) {
        //     dateValue = sefaData.IssueDate.HijriDate;
        //   } else {
        //     dateValue = this.formatHijriDate(sefaData.IssueDate.HijriDate);
        //   }


        // }

        // retList = retList.concat({
        //   Label: 'SefaProps.lawyerLicenseissueDate',
        //   Value: dateValue,
        // } as SefaAdditionalFeilds);

        // let lawyerLicenseexpiryDate = '';
        // if (sefaData.expiryDate != undefined) {

        //   if (sefaData.expiryDate.HijriDate.indexOf('/') > -1) {
        //     lawyerLicenseexpiryDate = sefaData.expiryDate.HijriDate;
        //   } else {
        //     lawyerLicenseexpiryDate = this.formatHijriDate(sefaData.expiryDate.HijriDate)
        //   }

        // }

        // if (sefaData.ExpiryDate != undefined) {
        //   if (sefaData.ExpiryDate.HijriDate.indexOf('/') > -1) {
        //     lawyerLicenseexpiryDate = sefaData.ExpiryDate.HijriDate;
        //   } else {
        //     lawyerLicenseexpiryDate = this.formatHijriDate(sefaData.ExpiryDate.HijriDate)
        //   }
        // }

        // retList = retList.concat({
        //   Label: 'SefaProps.lawyerLicenseexpiryDate',
        //   Value: lawyerLicenseexpiryDate,
        // } as SefaAdditionalFeilds);



        break;
      case PartySefaEnum.TrainerLawyer:
        retList = retList.concat({
          Label: 'SefaProps.trainerLawyerLicense',
          Value: sefaData.licenseNumber || sefaData.LicenseNumber,
        } as SefaAdditionalFeilds);
        break;
      default:
        break;
    }

    return retList;
  }

  public flattenClauses(tree: ClauseResponse[]): ClauseResponse[] {
    const result: ClauseResponse[] = [];

    function flatten(node: ClauseResponse) {
      result.push(node);
      if (node.clauses) {
        node.clauses.forEach(flatten);
      }
    }

    tree.forEach(flatten);
    return result;
  }

}
